import { connect } from 'react-redux'
import CreateAssessment from './create-assessment'
import {
  isOpen,
  getSelectedWorks,
  getSelectedWorksCount
} from './create-assessment.selectors'
import { getPupil } from '../../../../../stores/pupil/pupil.selectors'
import { closeCreateAssessmentDialog } from './create-assessment.actions'
import { createAssessmentFile } from '../../../../../stores/assessment/assessment.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const opened = isOpen(state)
  const pupil = getPupil(state)
  return {
    opened,
    id: pupil && pupil.account.id,
    name: pupil && pupil.account.full_name,
    works: getSelectedWorks(state),
    count: getSelectedWorksCount(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  requestClose: () => dispatch(closeCreateAssessmentDialog()),
  onSubmit: values => {
    dispatch(closeCreateAssessmentDialog())
    dispatch(
      createAssessmentFile({
        title: values.title,
        context: values.context,
        work_ids: stateProps.works.map(works => works.id),
        student_id: stateProps.id,
        moderation_type: values.moderation_type,
        judgement: values.judgement
      })
    )
      .then(resp => {
        return (window.location =
          '/moderation/assessment-files/' + resp.data.assessment_file.id)
      })
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CreateAssessment)
